module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    staticClass: "card is-fullwidth"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), (!!this.icon) ? _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa",
    class: [("fa-" + _vm.icon)]
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])]), _vm._v(" "), (!!this.$slots.footer) ? _c('footer', {
    staticClass: "card-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-eac14a0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-card/src/BaseCard.vue
// module id = 168
// module chunks = 34